import { DatePipe, DecimalPipe, HashLocationStrategy, LocationStrategy, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

import { PopoverModule } from 'ngx-bootstrap/popover';
import { LightboxModule } from 'ngx-lightbox';
import { ToastrModule } from 'ngx-toastr';
import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';


const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppFooterModule,
  AppHeaderModule,
  AppSidebarModule
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ChartsModule } from 'ng2-charts';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgxImageCompressService } from 'ngx-image-compress';
import { QuillModule } from 'ngx-quill';
import { JobsComponent } from './Configuration/jobs/jobs.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { HttpInterceptorInterceptor } from './http-interceptor.interceptor';
import { ReinspectionSurveyLinkComponent } from './motor-survey/Jobs/reinspection-survey-link/reinspection-survey-link.component';
import { RepairSurveyLinkComponent } from './motor-survey/Jobs/repair-survey-link/repair-survey-link.component';
import { SurveyLinkComponent } from './motor-survey/Jobs/survey-link/survey-link.component';
import { ConfirmationPopupComponent } from './Shared/components/confirmation-popup/confirmation-popup.component';

@NgModule({
  imports: [
    PopoverModule.forRoot(),
    LightboxModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    IconModule,
    IconSetModule.forRoot(),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    ModalModule,
    RouterModule,
    SweetAlert2Module.forRoot(),
    QuillModule.forRoot(),
  
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    LoginComponent,
    RegisterComponent,
    JobsComponent,
    CreatePasswordComponent,
    SurveyLinkComponent,
    RepairSurveyLinkComponent,
    ReinspectionSurveyLinkComponent,
    ConfirmationPopupComponent
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    IconSetService,
    NgxImageCompressService,
    TitleCasePipe,
    DecimalPipe,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
